new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if(contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if(photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');
    
                    if(photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');
    
                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                              content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }
        
                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                              activeTab(index);
                            });
                        });
                    }
                }
            }

            if(photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.resizeThumbs();
        this.clickThumbs();

         // Esconde o less-stock inicialmente
        const initialLessStock = document.querySelectorAll('.less-stock');
        initialLessStock.forEach(element => {
            element.style.display = 'none';
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_SELECTOR = '#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2';

        // Rastreia quais grupos o usuário já selecionou tamanho (não depende do DOM)
        const selectedGroups = new Set();

        const getGroups = () => Array.from(document.querySelectorAll(GROUP_SELECTOR));

        // Verifica se o grupo tem variações
        const hasVariations = (group) => {
            return group.querySelector('input[type="radio"], input[type="checkbox"], select, .product-radio-variation') !== null;
        };

        // Garante please-select em grupos novos e atualiza o botão
        const syncUI = () => {
            const groups = getGroups();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!addCartBtn) return;

            groups.forEach(group => {
                if (!selectedGroups.has(group.id) && hasVariations(group)) {
                    group.classList.add('please-select');
                }
            });

            // Considera "selecionado" se o grupo foi selecionado OU se não tem variações
            const allSelected = groups.length > 0 && groups.every(g => selectedGroups.has(g.id) || !hasVariations(g));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        // Marca grupo como selecionado pelo usuário
        const markSelected = (group) => {
            if (!group || !group.id) return;
            selectedGroups.add(group.id);
            group.classList.remove('please-select');
            syncUI();
        };

        const container = document.querySelector('#js_buy_together_api_layout_1_groups');
        if (!container) return;

        // change = seleção em select, radio, checkbox
        container.addEventListener('change', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;
            const group = target.closest(GROUP_SELECTOR);
            if (group) markSelected(group);
        }, { passive: true });

        // click em label/input = fallback para radios customizados
        container.addEventListener('click', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;
            if (target.closest('label') || target.matches('input')) {
                const group = target.closest(GROUP_SELECTOR);
                if (group) setTimeout(() => markSelected(group), 0);
            }
        }, { passive: true });

        // Observa novos grupos sendo adicionados para colocar please-select
        const observer = new MutationObserver(() => syncUI());
        observer.observe(container, { childList: true, subtree: true });

        // Inicializa
        syncUI();
    });

    let listBuyTogether = document.getElementById('js_buy_together_api_layout_1_groups'),
        options = {
            childList: true
        }
    if (listBuyTogether) {
        observer = new MutationObserver(Callback);
        observer.observe(listBuyTogether, options);

        function Callback() {
            const products = document.querySelectorAll('#js_buy_together_api_layout_1_groups ul');
            if (products.length) {
                products.forEach(product => {
                    if (product.dataset.buyTogetherBound) return;
                    product.dataset.buyTogetherBound = '1';

                    const options = product.querySelector('.product-item__options');
                    if (options) {
                        options.addEventListener('click', () => {
                            const radioVariation = options.querySelector('.product-radio-variation');
                            if (radioVariation) {
                                radioVariation.classList.toggle('active');
                            }
                            product.classList.toggle('active');
                        });

                        if (window.matchMedia("(max-width: 991px)").matches) {
                            const detailList = product.querySelector('.product-item__content--container');
                            if (detailList) {
                                detailList.appendChild(options);
                            }
                        }
                    }
                });
            }
        }
    }

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if (productRatings) {
          $('.product-ratings-list').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: true,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 2000,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  slidesToShow: 3,
                  adaptiveHeight: true,
                }
              },
              {
                breakpoint: 1270,
                settings: {
                  slidesToShow: 4,
                  slidesToShow: 4,
                  adaptiveHeight: true,
                }
              },
            ]
          });
      
          $('.product-ratings-list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
              selector: '.lazy-img',
              successClass: 'loaded-img',
              success: function (element) {
                setTimeout(function () {
                  var parent = element.previousSibling;
                  try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
              }
            });
          });
        }
      });

    const productRating = document.querySelector('.product-rating__review-list');
    if(productRating) {
        $('.product-rating__review-list').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
        function animeScroll() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            const sidebarInner = document.querySelector('.sidebar__inner');
    
            if (photoScroll && sidebarInner && photoScroll.offsetHeight > sidebarInner.offsetHeight) {
                const containerWidth = $('.product-detail__header--infoArea').width();
                const sidebarInnerHeight = sidebarInner.offsetHeight;
                const totalHeight = photoScroll.offsetHeight - sidebarInnerHeight;
                const pageTop = window.pageYOffset;
                const rect = photoScroll.getBoundingClientRect();
                const offsetTop = rect.top + pageTop; // Calculate the distance from top of the page to the photoScroll
    
                if (pageTop > (offsetTop + totalHeight)) {
                    $('.sidebar__inner').css({ position: 'relative', top: totalHeight + 'px', maxWidth: '100%' });
                } else if (pageTop > offsetTop) {
                    $('.sidebar__inner').css({ position: 'fixed', top: '0px', maxWidth: containerWidth + 'px' });
                } else {
                    $('.sidebar__inner').css({ position: 'relative', top: '0px', maxWidth: '100%' });
                    $('.sidebar__inner').css({ paddingTop: '0' + 'px' });
                }
            }
        }
    
        window.addEventListener('scroll', function() {
            animeScroll();
        });
    
        animeScroll();
    } 

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });
        
        observer.observe(brinde, {
            childList: true,
            subtree: true
        });
        
    }

    if($('.product-detail__header--photoArea-mobile')) {
        $('.product-detail__header--photoArea-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if($('#like-carousel')) {
        $('#like-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    
        $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function(element) {
                    setTimeout(function(){
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();
})

// Modal das fotos/vídeos das avaliações e da tabela de medidas: mesmo visual do fancybox v3 da plataforma,
// mas sem gravar #gallery-N na URL (o fancybox usa o hash para a navegação)
;(function () {
    var modal = null;
    var items = [];
    var index = 0;
    var touchStartX = null;
    // zoom por clique só com mouse; no celular fica a pinça nativa do navegador
    var canClickZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var zoom = { active: false, scale: 1, x: 0, y: 0, dragging: false, moved: false, startX: 0, startY: 0 };

    function build() {
        modal = document.createElement('div');
        modal.className = 'rating-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('tabindex', '-1');
        modal.innerHTML =
            '<div class="rating-modal__bg"></div>' +
            '<div class="rating-modal__controls">' +
                '<div class="rating-modal__infobar">' +
                    '<button type="button" class="rating-modal__button rating-modal__button--left js-rating-modal-prev" title="Previous"></button>' +
                    '<div class="rating-modal__infobar-body"><span class="js-rating-modal-index"></span>&nbsp;/&nbsp;<span class="js-rating-modal-count"></span></div>' +
                    '<button type="button" class="rating-modal__button rating-modal__button--right js-rating-modal-next" title="Next"></button>' +
                '</div>' +
                '<div class="rating-modal__buttons">' +
                    '<button type="button" class="rating-modal__button rating-modal__button--close js-rating-modal-close" title="Close (Esc)"></button>' +
                '</div>' +
            '</div>' +
            '<div class="rating-modal__slide js-rating-modal-slide"></div>' +
            '<div class="rating-modal__caption-wrap"><div class="rating-modal__caption js-rating-modal-caption"></div></div>';
        document.body.appendChild(modal);

        modal.querySelector('.js-rating-modal-prev').addEventListener('click', function () { go(index - 1); });
        modal.querySelector('.js-rating-modal-next').addEventListener('click', function () { go(index + 1); });
        modal.querySelector('.js-rating-modal-close').addEventListener('click', close);
        // clique fora da mídia fecha, como o clickSlide/clickOutside do fancybox
        modal.querySelector('.js-rating-modal-slide').addEventListener('click', function (e) {
            if (e.target === e.currentTarget) close();
        });

        // swipe só com um dedo e sem a página ampliada pela pinça, senão o gesto de
        // arrastar a imagem ampliada trocaria de slide
        modal.addEventListener('touchstart', function (e) {
            var pinched = window.visualViewport && window.visualViewport.scale > 1.01;
            touchStartX = e.touches.length === 1 && !pinched ? e.touches[0].clientX : null;
        }, { passive: true });
        modal.addEventListener('touchmove', function (e) {
            if (e.touches.length > 1) touchStartX = null;
        }, { passive: true });
        modal.addEventListener('touchend', function (e) {
            if (touchStartX === null) return;
            var diff = e.changedTouches[0].clientX - touchStartX;
            touchStartX = null;
            if (Math.abs(diff) > 50) go(diff < 0 ? index + 1 : index - 1);
        });

        if (canClickZoom) {
            var slide = modal.querySelector('.js-rating-modal-slide');
            slide.addEventListener('mousedown', zoomDragStart);
            document.addEventListener('mousemove', zoomDragMove);
            document.addEventListener('mouseup', zoomDragEnd);
        }
    }

    function zoomImage() {
        return modal.querySelector('.rating-modal__image');
    }

    function applyZoom() {
        var img = zoomImage();
        if (!img) return;
        img.style.transform = zoom.active ? 'translate(' + zoom.x + 'px, ' + zoom.y + 'px) scale(' + zoom.scale + ')' : '';
        modal.classList.toggle('rating-modal--zoomed', zoom.active);
    }

    function resetZoom() {
        zoom.active = false;
        zoom.dragging = false;
        zoom.x = 0;
        zoom.y = 0;
        if (modal) modal.classList.remove('rating-modal--zoomed', 'rating-modal--dragging');
    }

    // amplia até o tamanho real da foto (mínimo 2x), centrado no ponto clicado
    function zoomIn(img, clientX, clientY) {
        var rect = img.getBoundingClientRect();
        zoom.scale = Math.max(img.naturalWidth / rect.width, 2);
        var offsetX = clientX - (rect.left + rect.width / 2);
        var offsetY = clientY - (rect.top + rect.height / 2);
        zoom.x = -offsetX * (zoom.scale - 1);
        zoom.y = -offsetY * (zoom.scale - 1);
        zoom.active = true;
        clampZoom(img);
        applyZoom();
    }

    // não deixa arrastar a foto para fora da tela
    function clampZoom(img) {
        var w = img.offsetWidth * zoom.scale;
        var h = img.offsetHeight * zoom.scale;
        var maxX = Math.max((w - window.innerWidth) / 2, 0);
        var maxY = Math.max((h - window.innerHeight) / 2, 0);
        zoom.x = Math.min(Math.max(zoom.x, -maxX), maxX);
        zoom.y = Math.min(Math.max(zoom.y, -maxY), maxY);
    }

    function zoomDragStart(e) {
        var img = zoomImage();
        if (e.button !== 0 || !img || e.target !== img) return;
        e.preventDefault();
        zoom.dragging = true;
        zoom.moved = false;
        zoom.startX = e.clientX;
        zoom.startY = e.clientY;
    }

    function zoomDragMove(e) {
        if (!zoom.dragging || !zoom.active) return;
        var dx = e.clientX - zoom.startX;
        var dy = e.clientY - zoom.startY;
        if (!zoom.moved && Math.abs(dx) + Math.abs(dy) < 5) return;
        zoom.moved = true;
        modal.classList.add('rating-modal--dragging');
        zoom.x += dx;
        zoom.y += dy;
        zoom.startX = e.clientX;
        zoom.startY = e.clientY;
        clampZoom(zoomImage());
        applyZoom();
    }

    // clique sem arrastar alterna o zoom; arrastar só move a foto ampliada
    function zoomDragEnd(e) {
        if (!zoom.dragging) return;
        zoom.dragging = false;
        modal.classList.remove('rating-modal--dragging');
        if (zoom.moved) return;
        if (zoom.active) {
            resetZoom();
            applyZoom();
        } else {
            zoomIn(zoomImage(), e.clientX, e.clientY);
        }
    }

    function render() {
        var item = items[index];
        var slide = modal.querySelector('.js-rating-modal-slide');
        var media;

        if (item.type === 'video') {
            media = document.createElement('video');
            media.className = 'rating-modal__video';
            media.src = item.src;
            media.controls = true;
            media.autoplay = true;
            media.playsInline = true;
        } else {
            media = document.createElement('img');
            media.className = 'rating-modal__image';
            media.src = item.src;
            media.alt = '';
        }

        resetZoom();
        slide.innerHTML = '';
        slide.appendChild(media);

        modal.querySelector('.js-rating-modal-index').textContent = index + 1;
        modal.querySelector('.js-rating-modal-count').textContent = items.length;
        modal.querySelector('.js-rating-modal-caption').textContent = item.caption;
        modal.classList.toggle('rating-modal--can-zoom', canClickZoom && item.type !== 'video');
        modal.classList.toggle('rating-modal--show-infobar', items.length > 1);
        modal.classList.toggle('rating-modal--show-caption', !!item.caption);
        modal.querySelector('.js-rating-modal-prev').classList.toggle('rating-modal__button--disabled', index === 0);
        modal.querySelector('.js-rating-modal-next').classList.toggle('rating-modal__button--disabled', index === items.length - 1);
    }

    function go(newIndex) {
        if (newIndex < 0 || newIndex >= items.length || newIndex === index) return;
        index = newIndex;
        render();
    }

    function open(links, start) {
        if (!modal) build();
        items = links.map(function (link) {
            return {
                src: link.getAttribute('href'),
                type: link.dataset.type,
                caption: link.dataset.caption || ''
            };
        });
        index = start;
        render();
        document.documentElement.classList.add('rating-modal-enabled');
        modal.classList.add('rating-modal--open');
        // força o reflow para a transição do fundo rodar
        void modal.offsetWidth;
        modal.classList.add('rating-modal--ready');
        modal.focus();
    }

    function close() {
        if (!modal || !modal.classList.contains('rating-modal--open')) return;
        modal.querySelector('.js-rating-modal-slide').innerHTML = '';
        resetZoom();
        modal.classList.remove('rating-modal--open', 'rating-modal--ready');
        document.documentElement.classList.remove('rating-modal-enabled');
    }

    // delegado: a lista de avaliações fica dentro do #product-detail, que o Vue re-renderiza
    document.addEventListener('click', function (e) {
        var link = e.target.closest('.js-rating-modal');
        if (!link) return;
        e.preventDefault();
        // cada data-group é uma galeria (avaliações, tabela de medidas)
        var links = Array.prototype.slice.call(document.querySelectorAll('.js-rating-modal[data-group="' + link.dataset.group + '"]'));
        open(links, links.indexOf(link));
    });

    document.addEventListener('keydown', function (e) {
        if (!modal || !modal.classList.contains('rating-modal--open')) return;
        if (e.key === 'Escape') close();
        if (zoom.active) return;
        if (e.key === 'ArrowLeft') go(index - 1);
        if (e.key === 'ArrowRight') go(index + 1);
    });
})();